import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './PlanWarrantySection.module.scss';

const WarrantySection = ({ data }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  if (!data || !Array.isArray(data)) {
    return null;
  }

  if (data.length === 0) {
    return null;
  }

  return (
    <div className={styles.warrantySection}>
      {data.map((item, index) => {
        const reversed = index % 2 !== 0 ? styles.reversed : '';

        // 安全的字段提取函数
        const getItemFieldValue = (field) => {
          if (field?.value !== undefined) {
            return field.value;
          }
          return typeof field === 'string' ? field : '';
        };

        // 确保正确访问Sitecore数据结构，支持两种数据格式
        const itemFields = item?.fields || item;
        const imageUrl = getImageUrl(itemFields?.image);
        const title = getItemFieldValue(itemFields?.title);
        const description = getItemFieldValue(itemFields?.description);
        const buttonText = getItemFieldValue(itemFields?.buttonText);
        const buttonUrl =
          itemFields?.buttonUrl?.value?.href || getItemFieldValue(itemFields?.buttonUrl);
        const isComingSoon =
          itemFields?.isComingSoon?.value !== undefined
            ? itemFields?.isComingSoon?.value
            : itemFields?.isComingSoon || false;

        let actionElement = null;
        if (buttonText) {
          if (isComingSoon) {
            actionElement = <button className={styles.comingSoon}>Coming soon</button>;
          } else {
            actionElement = (
              <a href={buttonUrl} className={styles.button}>
                {buttonText}
              </a>
            );
          }
        }

        return (
          <div
            className={`${styles.warrantySectionItem} ${reversed}`}
            key={index}
            data-aos="fade-up"
          >
            {imageUrl && (
              <div className={styles.imageWrapper}>
                <img src={imageUrl} alt={title} className={styles.image} />
              </div>
            )}
            <div className={styles.content}>
              {title && <h2 className={styles.title}>{title}</h2>}
              {description && (
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              )}
              {actionElement}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WarrantySection;
